window.liquidPageLoaded = false;
window.liquidIsElementor =
  window.liquidIsElementor || document.body.classList.contains("elementor-page");
window.liquidCheckedFonts = [];

const pluginStore = new WeakMap();

function getPluginBucket(element) {
  if (!pluginStore.has(element)) {
    pluginStore.set(element, new Map());
  }
  return pluginStore.get(element);
}

function setPluginInstance(element, name, instance) {
  getPluginBucket(element).set(name, instance);
}

function getPluginInstance(element, name) {
  return getPluginBucket(element).get(name);
}

function toArray(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (value instanceof NodeList || value instanceof HTMLCollection) {
    return Array.from(value);
  }
  return [value];
}

function query(selector, root = document) {
  return root.querySelector(selector);
}

function queryAll(selector, root = document) {
  return Array.from(root.querySelectorAll(selector));
}

function addClasses(element, classNames) {
  if (!element || !classNames) return;
  element.classList.add(...classNames.split(/\s+/).filter(Boolean));
}

function removeClasses(element, classNames) {
  if (!element || !classNames) return;
  element.classList.remove(...classNames.split(/\s+/).filter(Boolean));
}

function css(element, styles) {
  if (!element || !styles) return;
  Object.entries(styles).forEach(([key, value]) => {
    element.style[key] = value;
  });
}

function getDataOptions(element, attribute) {
  if (!element) return {};
  const raw = element.getAttribute(attribute);
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

function getCssVariableNumber(element, property) {
  return parseFloat(getComputedStyle(element).getPropertyValue(property)) || 0;
}

function wrapInner(element, wrapperClassName) {
  if (!element || element.querySelector(":scope > ." + wrapperClassName)) return;
  const wrapper = document.createElement("span");
  wrapper.className = wrapperClassName;
  while (element.firstChild) {
    wrapper.appendChild(element.firstChild);
  }
  element.appendChild(wrapper);
}

function getSiblingsIndex(element, elements) {
  return elements.findIndex((item) => item === element);
}

window.liquidIsMobile = function () {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 0) ||
    navigator.platform === "iPad"
  );
};

window.liquidMobileNavBreakpoint = function () {
  if (window.liquidParams && window.liquidParams.mobileNavBreakpoint) {
    return window.liquidParams.mobileNavBreakpoint;
  }
  return Number(document.body.dataset.mobileNavBreakpoint || 1199);
};

window.liquidWindowWidth = function () {
  return window.innerWidth;
};

window.liquidWindowHeight = function () {
  return window.innerHeight;
};

window.liquidDocHeight = function () {
  return document.body.clientHeight;
};

window.liquidSlugify = function (str) {
  return String(str)
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

const restArguments = function (func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function () {
    let length = Math.max(arguments.length - startIndex, 0);
    let rest = Array(length);
    let index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0:
        return func.call(this, rest);
      case 1:
        return func.call(this, arguments[0], rest);
      case 2:
        return func.call(this, arguments[0], arguments[1], rest);
      default: {
        let args = Array(startIndex + 1);
        for (index = 0; index < startIndex; index++) {
          args[index] = arguments[index];
        }
        args[startIndex] = rest;
        return func.apply(this, args);
      }
    }
  };
};

const liquidDelay = restArguments(function (func, wait, args) {
  return setTimeout(function () {
    return func.apply(null, args);
  }, wait);
});

const liquidNow =
  Date.now ||
  function () {
    return new Date().getTime();
  };

window.liquidThrottle = function (func, wait, options) {
  let timeout;
  let context;
  let args;
  let result;
  let previous = 0;
  if (!options) options = {};
  let later = function () {
    previous = options.leading === false ? 0 : liquidNow();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  let throttled = function () {
    let now = liquidNow();
    if (!previous && options.leading === false) previous = now;
    let remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };
  return throttled;
};

window.liquidDebounce = function (func, wait, immediate) {
  let timeout;
  let result;
  let later = function (context, args) {
    timeout = null;
    if (args) result = func.apply(context, args);
  };
  let debounced = restArguments(function (args) {
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      let callNow = !timeout;
      timeout = setTimeout(later, wait);
      if (callNow) result = func.apply(this, args);
    } else {
      timeout = liquidDelay(later, wait, this, args);
    }
    return result;
  });
  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };
  return debounced;
};

window.liquidGetMousePos = (ev, basedOnElement) => {
  let posx = 0;
  let posy = 0;
  if (!ev) ev = window.event;
  if (ev.pageX || ev.pageY) {
    posx = ev.pageX;
    posy = ev.pageY;
  } else if (ev.clientX || ev.clientY) {
    posx =
      ev.clientX +
      document.body.scrollLeft +
      document.documentElement.scrollLeft;
    posy =
      ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }
  if (basedOnElement && ev.currentTarget) {
    const rect = ev.currentTarget.getBoundingClientRect();
    posx = posx - rect.left - window.scrollX;
    posy = posy - rect.top - window.scrollY;
  }
  return { x: posx, y: posy };
};

window.liquidElements = function () {
  window.$liquidWindow = window;
  window.$liquidHtml = document.documentElement;
  window.$liquidBody = document.body;
  window.$liquidSiteWrap = query("#wrap");
  window.$liquidContents = query("#lqd-site-content");
  window.$liquidContentsWrap = query("#lqd-contents-wrap");
  window.$liquidMainHeader = query(".main-header");
  window.$liquidMainFooter = query(".main-footer");
  window.$liquidSectionsWrapper = window.$liquidContentsWrap;
  const isPfSinglePage = document.body.classList.contains(
    "single-liquid-portfolio",
  );
  const isBlogSinglePage = document.body.classList.contains("lqd-blog-post");

  if (window.liquidIsElementor && window.$liquidContentsWrap) {
    const secWrap = query(".elementor-section-wrap", window.$liquidContentsWrap);
    window.$liquidSectionsWrapper = secWrap || query(":scope > .elementor", window.$liquidContentsWrap) || window.$liquidContentsWrap;
  }

  if (isPfSinglePage) {
    window.$liquidSectionsWrapper = query(".pf-single-contents") || window.$liquidSectionsWrapper;
    const elementorWrapper = window.$liquidSectionsWrapper?.querySelector(":scope > .elementor");
    if (elementorWrapper) {
      window.$liquidSectionsWrapper = elementorWrapper;
    }
  }

  if (isBlogSinglePage) {
    window.$liquidSectionsWrapper =
      query(".lqd-single-post-content > .container") || window.$liquidSectionsWrapper;
    const elementorWrapper = window.$liquidSectionsWrapper?.querySelector(":scope > .elementor");
    if (elementorWrapper) {
      window.$liquidSectionsWrapper = elementorWrapper;
    }
  }

  const directSections = window.$liquidContentsWrap
    ? Array.from(window.$liquidContentsWrap.children).filter(
        (child) => child.tagName === "SECTION",
      )
    : [];

  window.$liquidSections = directSections;
  window.liquidBodyBg = getComputedStyle(document.body).backgroundColor;
  window.liquidContentsBg = window.$liquidContents
    ? getComputedStyle(window.$liquidContents).backgroundColor
    : "rgba(0, 0, 0, 0)";
  window.liquidMainFooterBg = window.$liquidMainFooter
    ? getComputedStyle(window.$liquidMainFooter).backgroundColor
    : "rgba(0, 0, 0, 0)";
};

if (liquidIsMobile()) {
  document.documentElement.classList.add("vc_mobile");
  document.body.setAttribute("data-elementor-device-mode", "mobile");
}

liquidElements();
window.liquidHeaderIsElementor = false;
window.liquidLazyloadEnabled = document.body.classList.contains(
  "lazyload-enabled",
);

const fastdomPromised = {
  measure(callback) {
    return Promise.resolve().then(callback);
  },
  mutate(callback) {
    return Promise.resolve().then(callback);
  },
};

class LiquidSectionsDetails {
  constructor() {
    this.sections = [];
    this.footerBg =
      tinycolor(window.liquidMainFooterBg).getAlpha() === 0
        ? window.liquidBodyBg
        : window.liquidMainFooterBg;
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new LiquidSectionsDetails();
    }
    return this.instance;
  }

  static async getDetails() {
    const instance = this.getInstance();
    if (instance.sections.length) {
      return instance.sections;
    }

    const sections = window.$liquidSections || [];
    instance.sections = sections.map((section) => {
      const styles = getComputedStyle(section);
      const predefinedLuminosity = section.getAttribute("data-section-luminosity");
      let backgroundColor = styles.backgroundColor;

      if (tinycolor(backgroundColor).getAlpha() === 0) {
        backgroundColor = window.liquidContentsBg;
      }

      const luminosity = predefinedLuminosity || (tinycolor(backgroundColor).isDark() ? "dark" : "light");
      section.setAttribute("data-section-luminosity", luminosity);

      return {
        el: section,
        backgroundColor,
        luminosity,
        isInFooter: false,
        isInnerSection: false,
      };
    });

    return instance.sections;
  }
}

class LiquidPreloader {
  static pluginName = "liquidPreloader";
  static defaults = {
    animationType: "fade",
    animationTargets: "self",
    dir: "x",
    stagger: 0,
    duration: 1400,
  };

  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      ...LiquidPreloader.defaults,
      ...getDataOptions(element, "data-preloader-options"),
      ...options,
    };
    this.animationTargets = this.getAnimationTargets();
    this.onPreloaderHiddenEvent = new CustomEvent("lqd-preloader-anim-done");
    this.onPageLoad();
  }

  getAnimationTargets() {
    if (this.options.animationTargets === "self") {
      return [this.element];
    }
    return queryAll(this.options.animationTargets);
  }

  getAnimationProperties() {
    const { animationType } = this.options;
    if (animationType === "slide") {
      const dir = this.options.dir;
      return {
        animateOut: {
          [dir]: ["0%", "-100%"],
        },
      };
    }
    if (animationType === "scale") {
      return {
        animateOut: {
          [`scale${this.options.dir.toUpperCase()}`]: [1, 0],
        },
      };
    }
    return {
      animateOut: {
        opacity: [1, 0],
      },
    };
  }

  onPageLoad() {
    addClasses(document.body, "lqd-page-loaded lqd-preloader-animations-started");
    removeClasses(document.body, "lqd-page-leaving lqd-page-not-loaded");
    this.hidePreloader();
  }

  hidePreloader() {
    const stagger = this.options.stagger / 1000;
    const duration = this.options.duration / 1000;
    const timeline = gsap.timeline({
      defaults: {
        duration,
        ease: "expo.out",
      },
      onComplete: () => {
        this.element.style.display = "none";
        removeClasses(document.body, "lqd-preloader-animations-started");
        addClasses(document.body, "lqd-preloader-animations-done");
        this.animationTargets.forEach((target) => {
          target.style.transform = "";
        });
        document.dispatchEvent(this.onPreloaderHiddenEvent);
      },
    });

    this.animationTargets.forEach((targetElement, index) => {
      const animations = getDataOptions(targetElement, "data-animations");
      if (Object.keys(animations).length) {
        timeline.to(targetElement, { ...animations }, stagger * index);
        return;
      }

      const animationProperties = this.getAnimationProperties().animateOut;
      const property = Object.keys(animationProperties)[0];
      const [fromValue, toValue] = animationProperties[property];
      timeline.fromTo(
        targetElement,
        { [property]: fromValue },
        { [property]: toValue },
        stagger * index,
      );
    });
  }

  static init(element, options) {
    const existing = getPluginInstance(element, LiquidPreloader.pluginName);
    if (existing) return existing;
    const instance = new LiquidPreloader(element, options);
    setPluginInstance(element, LiquidPreloader.pluginName, instance);
    return instance;
  }
}

class LiquidSplitText {
  static pluginName = "liquidSplitText";
  static defaults = {
    type: "words",
    forceApply: false,
  };

  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      ...LiquidSplitText.defaults,
      ...getDataOptions(element, "data-split-options"),
      ...options,
    };
    this.splittedTextList = {
      lines: [],
      words: [],
      chars: [],
    };
    this.splitTextInstance = null;
    this.isRTL = document.documentElement.getAttribute("dir") === "rtl";
    this.prevWindowWidth = window.innerWidth;
    this.fontInfo = {};
    this.handleResize = this.onWindowResize.bind(this);
    this.splitDonePormise = new Promise((resolve) => {
      this.element.addEventListener(
        "lqdsplittext",
        () => resolve(this),
        { once: true },
      );
    });

    if (!this.options.forceApply) {
      new IntersectionObserver(
        ([entry], observer) => {
          if (entry.isIntersecting) {
            observer.disconnect();
            this.init();
          }
        },
        { rootMargin: "20%" },
      ).observe(this.element);
    } else {
      this.init();
    }
  }

  async init() {
    await this.measure();
    await this.onFontsLoad();
    this.bindResize();
  }

  measure() {
    return fastdomPromised.measure(() => {
      const styles = getComputedStyle(this.element);
      this.fontInfo.elementFontFamily = styles.fontFamily
        .replace(/"/g, "")
        .replace(/'/g, "")
        .split(",")[0];
      this.fontInfo.elementFontWeight = styles.fontWeight;
      this.fontInfo.elementFontStyle = styles.fontStyle;
      this.fontInfo.fontFamilySlug = window.liquidSlugify(
        this.fontInfo.elementFontFamily,
      );
    });
  }

  onFontsLoad() {
    return fastdomPromised.measure(() => {
      if (
        window.liquidCheckedFonts.find(
          (fontFamily) => fontFamily === this.fontInfo.fontFamilySlug,
        )
      ) {
        return this.doSplit();
      }

      const font = new FontFaceObserver(this.fontInfo.elementFontFamily, {
        weight: this.fontInfo.elementFontWeight,
        style: this.fontInfo.elementFontStyle,
      });

      return font.load().finally(() => {
        window.liquidCheckedFonts.push(this.fontInfo.fontFamilySlug);
        this.doSplit();
      });
    });
  }

  getSplitTypeArray() {
    const splitTypes = this.options.type
      .split(",")
      .map((item) => item.replace(" ", ""));

    if (!this.isRTL) {
      return splitTypes;
    }

    return splitTypes.filter((type) => type !== "chars");
  }

  async doSplit() {
    await this.split();
    await this.unitsOp();
    await this.onSplittingDone();
  }

  split() {
    const splitType = this.getSplitTypeArray();
    const fancyHeadingInner =
      this.element.classList.contains("ld-fh-txt") &&
      this.element.querySelector(".ld-fh-txt-inner") != null;
    const target = fancyHeadingInner
      ? this.element.querySelector(".ld-fh-txt-inner")
      : this.element;

    return fastdomPromised.mutate(() => {
      this.splittedTextList = { lines: [], words: [], chars: [] };
      this.splitTextInstance = new SplitText(target, {
        type: splitType,
        charsClass: "split-unit lqd-chars",
        linesClass: "split-unit lqd-lines",
        wordsClass: "split-unit lqd-words",
      });

      splitType.forEach((type) => {
        this.splitTextInstance[type].forEach((splitElement) => {
          this.splittedTextList[type].push(splitElement);
        });
      });

      this.element.classList.add("split-text-applied");
    });
  }

  unitsOp() {
    return fastdomPromised.mutate(() => {
      Object.entries(this.splittedTextList).forEach(
        ([splitType, splittedTextArray]) => {
          if (!splittedTextArray || !splittedTextArray.length) return;

          splittedTextArray.forEach((splitElement, index) => {
            splitElement.style.setProperty(`--${splitType}-index`, index);
            splitElement.style.setProperty(
              `--${splitType}-last-index`,
              splittedTextArray.length - 1 - index,
            );
            wrapInner(splitElement, "split-inner");
          });
        },
      );
    });
  }

  onSplittingDone() {
    return fastdomPromised.mutate(() => {
      this.element.dispatchEvent(new CustomEvent("lqdsplittext"));
    });
  }

  bindResize() {
    window.addEventListener("resize", this.handleResize);
  }

  onWindowResize() {
    if (this.prevWindowWidth === window.innerWidth) return;
    if (this.splitTextInstance) {
      this.splitTextInstance.revert();
      this.element.classList.remove("split-text-applied");
    }
    this.doSplit();
    this.onSplittingDone();
    queryAll(".split-unit", this.element).forEach((unit) => {
      unit.classList.add("lqd-unit-animation-done");
    });
    this.prevWindowWidth = window.innerWidth;
  }

  destroy() {
    window.removeEventListener("resize", this.handleResize);
  }

  static init(element, options) {
    const existing = getPluginInstance(element, LiquidSplitText.pluginName);
    if (existing) return existing;
    const instance = new LiquidSplitText(element, options);
    setPluginInstance(element, LiquidSplitText.pluginName, instance);
    return instance;
  }
}

class LiquidCustomAnimations {
  static pluginName = "liquidCustomAnimations";
  static defaults = {
    delay: 160,
    startDelay: 0,
    direction: "forward",
    duration: 1600,
    ease: "power4.out",
    animationTarget: "this",
    addPerspective: true,
    perspectiveVal: 1400,
    initValues: {
      x: 0,
      y: 0,
      z: 0,
      rotationX: 0,
      rotationY: 0,
      rotationZ: 0,
      scaleX: 1,
      scaleY: 1,
      scaleZ: 1,
      opacity: 1,
      transformOriginX: 50,
      transformOriginY: 50,
      transformOriginZ: "0px",
    },
    animations: {
      x: 0,
      y: 0,
      z: 0,
      rotationX: 0,
      rotationY: 0,
      rotationZ: 0,
      scaleX: 1,
      scaleY: 1,
      scaleZ: 1,
      opacity: 1,
      transformOriginX: 50,
      transformOriginY: 50,
      transformOriginZ: "0px",
    },
    clearProps: "transform,opacity,transform-origin",
    randomizeInitValues: false,
  };

  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      ...LiquidCustomAnimations.defaults,
      ...getDataOptions(element, "data-ca-options"),
      ...options,
    };
    this.options.duration = this.options.duration / 1000;
    this.options.delay = this.options.delay / 1000;
    this.options.startDelay = this.options.startDelay / 1000;
    this.animationTargets = [];
    this.animationsTimeline = null;
    this.animationsStarted = false;
    this.needPerspective =
      this.options.addPerspective && this.needPerspectiveCheck();
    this.animationsInitiatedPromise = new Promise((resolve) => {
      this.element.addEventListener(
        "lqdanimationsinitiated",
        () => resolve(this),
        { once: true },
      );
    });
    this.animationsDonePromise = new Promise((resolve) => {
      this.element.addEventListener("lqdanimationsdone", () => resolve(this), {
        once: true,
      });
    });

    new IntersectionObserver(
      ([entry], observer) => {
        if (entry.isIntersecting) {
          observer.disconnect();
          this.build();
        }
      },
      { rootMargin: "8%" },
    ).observe(this.element);
  }

  build() {
    const splitTextElements = queryAll("[data-split-text]", this.element);
    if (this.element.hasAttribute("data-split-text")) {
      splitTextElements.push(this.element);
    }

    const promises = splitTextElements.map((element) => {
      const instance = LiquidSplitText.init(element, { forceApply: true });
      return instance.splitDonePormise;
    });

    if (promises.length) {
      Promise.all(promises).then(() => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.getAnimationTargets();
    this.createTimeline();
    this.initValues();
    this.runAnimations();
  }

  getAnimationTargets() {
    const { animationTarget } = this.options;
    if (animationTarget === "this") {
      this.animationTargets = [this.element];
      return;
    }
    if (animationTarget === "all-childs") {
      this.animationTargets = this.getInnerChildElements(
        Array.from(this.element.children),
      );
      return;
    }
    this.animationTargets = queryAll(animationTarget, this.element);
  }

  getInnerChildElements(elements) {
    const elementsArray = [];

    elements.forEach((element) => {
      if (element.hasAttribute("data-custom-animations")) {
        elementsArray.push(element);
        return;
      }

      const customAnimationChildren = queryAll("[data-custom-animations]", element);
      if (customAnimationChildren.length) {
        elementsArray.push(...customAnimationChildren);
        return;
      }

      if (element.tagName === "UL") {
        elementsArray.push(...Array.from(element.children));
        return;
      }

      if (
        queryAll("[data-split-text]", element).length ||
        element.hasAttribute("data-split-text")
      ) {
        if (element.classList.contains("btn")) {
          elementsArray.push(element);
        } else {
          queryAll(".split-inner", element).forEach((splitInner) => {
            const nested = query(".split-inner", splitInner);
            elementsArray.push(nested || splitInner);
          });
        }
        return;
      }

      if (
        !element.classList.contains("vc_empty_space") &&
        !element.classList.contains("ld-empty-space") &&
        !element.hasAttribute("data-split-text") &&
        element.tagName !== "STYLE"
      ) {
        elementsArray.push(element);
      }
    });

    return elementsArray;
  }

  needPerspectiveCheck() {
    const valuesNeedPerspective = ["z", "rotationX", "rotationY"];
    return Object.keys(this.options.initValues).some((prop) =>
      valuesNeedPerspective.includes(prop),
    );
  }

  generateRandomValues(valuesObject) {
    const object = { ...valuesObject };
    Object.keys(valuesObject).forEach((key) => {
      if (key.search("transformOrigin") < 0 && key.search("opacity") < 0) {
        object[key] = () => gsap.utils.random(0, valuesObject[key]);
      }
    });
    return object;
  }

  createTimeline() {
    const { ease, duration, clearProps } = this.options;
    this.animationsTimeline = gsap.timeline({
      defaults: {
        duration,
        ease,
        clearProps,
      },
      onComplete: this.onTimelineAnimationComplete.bind(this),
    });
  }

  initValues() {
    const { randomizeInitValues, initValues } = this.options;
    const initProps = !randomizeInitValues
      ? initValues
      : this.generateRandomValues(initValues);

    this.animationTargets.forEach((target) => {
      target.style.transition = "none";
      target.style.transitionDelay = 0;
      target.classList.add("will-change");
    });

    if (this.needPerspective) {
      this.animationTargets.forEach((target) => {
        target.parentElement?.parentElement?.classList.add("perspective");
        if (!target.classList.contains("lqd-imggrp-single")) {
          target.parentElement?.classList.add("transform-style-3d");
        }
      });
    }

    gsap.set(this.animationTargets, { ...initProps });
    this.element.classList.add("ca-initvalues-applied");
    this.element.dispatchEvent(new CustomEvent("lqdanimationsinitiated"));
  }

  runAnimations() {
    const { delay, startDelay, animations, direction } = this.options;
    const stagger = {
      from:
        direction === "forward"
          ? "start"
          : direction === "backward"
            ? "end"
            : direction,
      each: delay,
    };

    this.animationsTimeline.to(this.animationTargets, {
      ...animations,
      stagger,
      delay: startDelay,
      onStart: () => {
        this.animationsStarted = true;
      },
      onComplete: () => {
        this.onUnitsAnimationsComplete(this.animationTargets);
      },
    });
  }

  onTimelineAnimationComplete() {
    if (this.needPerspective) {
      this.animationTargets.forEach((target) => {
        target.parentElement?.parentElement?.classList.remove("perspective");
        target.parentElement?.classList.remove("transform-style-3d");
      });
    }
    this.element.classList.add("lqd-animations-done");
    this.element.dispatchEvent(new CustomEvent("lqdanimationsdone"));
  }

  onUnitsAnimationsComplete(animationTargets) {
    animationTargets.forEach((element) => {
      element.style.transition = "";
      element.style.transitionDelay = "";
      element.classList.remove("will-change");
      if (element.classList.contains("split-inner")) {
        element.parentElement?.classList.add("lqd-unit-animation-done");
      } else {
        element.classList.add("lqd-unit-animation-done");
      }
    });
  }

  static handleTransformOrigins(options) {
    if (!options) return options;
    const next = { ...options };
    const { transformOriginX, transformOriginY, transformOriginZ } = next;

    if (typeof transformOriginX === "number") {
      next.transformOriginX = `${transformOriginX}%`;
    }
    if (typeof transformOriginY === "number") {
      next.transformOriginY = `${transformOriginY}%`;
    }
    if (typeof transformOriginZ === "number") {
      next.transformOriginZ = `${transformOriginZ}%`;
    }
    if (next.transformOriginX && next.transformOriginY && next.transformOriginZ) {
      next.transformOrigin = `${next.transformOriginX} ${next.transformOriginY} ${next.transformOriginZ}`;
      delete next.transformOriginX;
      delete next.transformOriginY;
      delete next.transformOriginZ;
    }

    return next;
  }

  static init(element, options) {
    const existing = getPluginInstance(element, LiquidCustomAnimations.pluginName);
    if (existing) return existing;
    const pluginOptions = {
      ...getDataOptions(element, "data-ca-options"),
      ...options,
    };
    pluginOptions.initValues = LiquidCustomAnimations.handleTransformOrigins(
      pluginOptions.initValues,
    );
    pluginOptions.animations = LiquidCustomAnimations.handleTransformOrigins(
      pluginOptions.animations,
    );
    const instance = new LiquidCustomAnimations(element, pluginOptions);
    setPluginInstance(element, LiquidCustomAnimations.pluginName, instance);
    return instance;
  }
}

class LiquidStickyHeader {
  static pluginName = "liquidStickyHeader";
  static defaults = {
    disableOnMobile: true,
    dynamicColors: true,
  };

  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      ...LiquidStickyHeader.defaults,
      ...getDataOptions(element, "data-sticky-options"),
      ...options,
    };
    this.placeholder = query(".lqd-sticky-placeholder");
    this.headModules = queryAll(".lqd-head-col > .header-module", element);
    this.initialOffsetTop = this.element.offsetTop;
    this.handleScroll = this.onScroll.bind(this);
    this.handleResize = this.onResize.bind(this);
    this.measure();
    this.bindEvents();
    this.onScroll();
  }

  shouldDisable() {
    return (
      this.options.disableOnMobile &&
      (liquidIsMobile() || liquidWindowWidth() <= liquidMobileNavBreakpoint())
    );
  }

  measure() {
    const height = this.element.getBoundingClientRect().height;
    document.documentElement.style.setProperty(
      "--lqd-sticky-header-height",
      `${height}px`,
    );
    document.documentElement.style.setProperty(
      "--lqd-sticky-header-placeholder-height",
      `${height}px`,
    );
  }

  bindEvents() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize);
  }

  onResize() {
    this.measure();
    this.initialOffsetTop = this.element.offsetTop;
    this.onScroll();
  }

  onScroll() {
    if (this.shouldDisable()) {
      this.element.classList.remove("is-stuck", "is-not-stuck");
      this.element.classList.add("is-not-stuck");
      if (this.placeholder) this.placeholder.classList.add("hidden");
      return;
    }

    const isStuck = window.scrollY > this.initialOffsetTop;
    this.element.classList.toggle("is-stuck", isStuck);
    this.element.classList.toggle("is-not-stuck", !isStuck);

    if (this.placeholder) {
      this.placeholder.classList.toggle("hidden", !isStuck);
    }
  }

  static init(element, options) {
    const existing = getPluginInstance(element, LiquidStickyHeader.pluginName);
    if (existing) return existing;
    const instance = new LiquidStickyHeader(element, options);
    setPluginInstance(element, LiquidStickyHeader.pluginName, instance);
    return instance;
  }
}

class LiquidStack {
  static pluginName = "liquidStack";
  static defaults = {
    anchors: [],
    easing: "linear",
    scrollingSpeed: "1.2s",
    loopTop: false,
    loopBottom: false,
    navigation: false,
    defaultTooltip: "Section",
    prevNextButtons: true,
    prevNextLabels: {
      prev: "Previous",
      next: "Next",
    },
    pageNumber: true,
    effect: "none",
    disableOnMobile: true,
    touchSensitivity: 5,
  };

  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      ...LiquidStack.defaults,
      ...getDataOptions(element, "data-stack-options"),
      ...options,
    };

    if (
      this.options.disableOnMobile &&
      (liquidIsMobile() || liquidWindowWidth() <= liquidMobileNavBreakpoint())
    ) {
      return;
    }

    this.lastScrolledDestiny = "";
    this.lastAnimation = 0;
    this.scrollings = [];
    this.isTouch =
      "ontouchstart" in window ||
      navigator.msMaxTouchPoints > 0 ||
      navigator.maxTouchPoints > 0;
    this.touchStartY = 0;
    this.touchEndY = 0;
    this.prevTime = Date.now();
    this.scrollDelay = 600;
    this.anchors = [];
    this.tooltips = [];
    this.sectionElements = [];
    this.ppNav = null;
    this.ppNavCurrentSpan = null;
    this.prevNextWrap = query(".lqd-stack-prevnext-wrap");
    this.pageNumber = query(".lqd-stack-page-number");
    this.pageNumbersStyle = document.body.classList.contains("lqd-stack-nums-style-1")
      ? "style1"
      : document.body.classList.contains("lqd-stack-nums-style-2")
        ? "style2"
        : "";
    this.mainNavLocalScroll = queryAll(".main-nav");
    this.handleWheel = this.mouseWheelHandler.bind(this);
    this.handleKeydown = this.keydownHandler.bind(this);
    this.handleTouchStart = this.touchStartHandler.bind(this);
    this.handleTouchMove = this.touchMoveHandler.bind(this);
    this.handleHashChange = this.hashChangeHandler.bind(this);
    this.stackInitPromise = Promise.resolve(this);

    this.element.style.setProperty(
      "--lqd-stack-animation-speed",
      this.options.scrollingSpeed,
    );

    LiquidSectionsDetails.getDetails().then((sections) => {
      const contentSections = sections.filter(
        (section) => !section.isInFooter && !section.isInnerSection,
      );
      this.sectionElements = contentSections.map((section) => section.el);
      this.build();
      this.addClassnames();
      this.eachSection();
      this.init();
      this.element.dispatchEvent(new CustomEvent("stackinit"));
    });
  }

  build() {
    this.buildNavigationMarkup();
  }

  addClassnames() {
    this.sectionElements.forEach((section) => {
      section.classList.add("pp-section");
    });

    if (this.options.navigation) {
      document.body.classList.add("lqd-stack-has-nav");
    }
    if (this.options.prevNextButtons) {
      document.body.classList.add("lqd-stack-has-prevnext-buttons");
    }
    if (this.options.pageNumber) {
      document.body.classList.add("lqd-stack-has-page-numbers");
    }
    if (this.options.effect !== "none") {
      document.body.classList.add("lqd-stack-effect-enabled");
    }

    document.body.classList.add(`lqd-stack-effect-${this.options.effect}`);
    document.documentElement.classList.add("html-pp-enabled", "overflow-hidden");
    document.body.classList.add("pp-enabled");
  }

  eachSection() {
    this.sectionElements.forEach((section, index) => {
      this.makeScrollable(section);
      this.setAnchors(index, section);
      this.setTooltips(index, section);
      this.addNavigationItem(index);
      section.addEventListener("animationend", (event) => {
        if (event.target === section) {
          removeClasses(
            section,
            "lqd-stack-row-entering lqd-stack-row-leaving lqd-stack-moving-up lqd-stack-moving-down",
          );
        }
      });
    });
  }

  makeScrollable(section) {
    const children = Array.from(section.children).filter((child) => {
      const position = getComputedStyle(child).position;
      return position !== "absolute" && position !== "fixed";
    });

    const sectionHeight = section.getBoundingClientRect().height;
    const childrenHeight = children.reduce(
      (total, child) => total + child.getBoundingClientRect().height,
      0,
    );

    if (childrenHeight > sectionHeight) {
      const style = getComputedStyle(section);
      const sectionPadding =
        parseInt(style.paddingTop, 10) + parseInt(style.paddingBottom, 10);
      section.classList.add("pp-scrollable");
      section.style.setProperty(
        "--lqd-section-height",
        `${childrenHeight + sectionPadding}px`,
      );
      return;
    }

    section.classList.remove("pp-scrollable");
    section.style.removeProperty("--lqd-section-height");
  }

  setAnchors(index, section) {
    let anchor = "";
    let hasAnchorAttr = false;

    if (section.hasAttribute("id")) {
      anchor = section.getAttribute("id");
    } else if (section.hasAttribute("data-tooltip")) {
      anchor = section.getAttribute("data-tooltip").replace(/ /g, "-").toLowerCase();
    } else if (!section.hasAttribute("data-anchor")) {
      anchor = `${this.options.defaultTooltip}-${index + 1}`;
    } else {
      hasAnchorAttr = true;
      anchor = section.getAttribute("data-anchor");
    }

    this.anchors[index] = anchor;
    if (!hasAnchorAttr) {
      section.setAttribute("data-anchor", anchor);
    }
  }

  setTooltips(index, section) {
    this.tooltips[index] = section.hasAttribute("data-tooltip")
      ? section.getAttribute("data-tooltip")
      : `${this.options.defaultTooltip} ${index + 1}`;
  }

  buildNavigationMarkup() {
    this.ppNav?.remove();

    this.ppNav = document.createElement("div");
    this.ppNav.id = "pp-nav";
    this.ppNav.innerHTML = `
      <div class="pp-nav-inner">
        <span class="pp-nav-current"><span></span></span>
        <ul class="pp-nav-ul reset-ul"></ul>
        <span class="pp-nav-total"></span>
      </div>
    `;
    document.body.appendChild(this.ppNav);
    this.ppNavCurrentSpan = query(".pp-nav-current > span", this.ppNav);
    const total = query(".pp-nav-total", this.ppNav);
    total.textContent = `${this.sectionElements.length < 10 ? "0" : ""}${this.sectionElements.length}`;
  }

  addNavigationItem(index) {
    const currentSpan = document.createElement("span");
    currentSpan.textContent = `${index + 1 < 10 ? "0" : ""}${index + 1}`;
    this.ppNavCurrentSpan.appendChild(currentSpan);

    const li = document.createElement("li");
    li.dataset.tooltip = this.tooltips[index];
    li.innerHTML = `
      <a href="#${this.anchors[index]}"><span></span></a>
      <span class="pp-tooltip">${this.tooltips[index]}</span>
    `;
    li.querySelector("a")?.addEventListener("click", (event) => {
      event.preventDefault();
      this.moveTo(index + 1);
    });
    query("ul", this.ppNav)?.appendChild(li);
  }

  init() {
    window.scrollTo(0, 0);
    this.addMouseWheelHandler();
    this.handleKeys();
    this.addTouchHandler();

    if (!this.lastScrolledDestiny) {
      this.setActiveSection(0);
      this.activateNavDots(0);
      this.addLuminosityClassnames(0);
    }

    this.scrollToAnchor();
    this.afterRender();
    window.addEventListener("hashchange", this.handleHashChange);
  }

  addMouseWheelHandler() {
    window.addEventListener("wheel", this.handleWheel, { passive: true });
  }

  handleKeys() {
    document.addEventListener("keydown", this.handleKeydown);
  }

  keydownHandler(event) {
    if (this.isMoving()) return;

    switch (event.which || event.keyCode) {
      case 38:
      case 33:
        this.moveSectionUp();
        break;
      case 40:
      case 34:
        this.moveSectionDown();
        break;
      case 36:
        this.moveTo(1);
        break;
      case 35:
        this.moveTo(this.sectionElements.length);
        break;
      default:
        break;
    }
  }

  addTouchHandler() {
    if (!this.isTouch) return;
    this.element.addEventListener("touchstart", this.handleTouchStart, {
      passive: true,
    });
    this.element.addEventListener("touchmove", this.handleTouchMove, {
      passive: false,
    });
  }

  getActiveSection() {
    const index = this.sectionElements.findIndex((section) =>
      section.classList.contains("active"),
    );
    return {
      element: this.sectionElements[index],
      index,
    };
  }

  setActiveSection(index) {
    this.sectionElements.forEach((section, sectionIndex) => {
      section.classList.toggle("active", sectionIndex === index);
    });
  }

  moveSectionUp() {
    const { index } = this.getActiveSection();
    const prevIndex = index - 1;
    if (prevIndex >= 0) {
      this.scrollPage(this.sectionElements[prevIndex]);
    } else if (this.options.loopTop) {
      this.scrollPage(this.sectionElements[this.sectionElements.length - 1]);
    }
  }

  moveSectionDown() {
    const { index } = this.getActiveSection();
    const nextIndex = index + 1;
    if (nextIndex < this.sectionElements.length) {
      this.scrollPage(this.sectionElements[nextIndex]);
    } else if (this.options.loopBottom) {
      this.scrollPage(this.sectionElements[0]);
    }
  }

  moveTo(section) {
    const destination = Number.isNaN(Number(section))
      ? this.sectionElements.find(
          (element) => element.getAttribute("data-anchor") === section,
        )
      : this.sectionElements[section - 1];

    if (destination) {
      this.scrollPage(destination);
    }
  }

  getYMovement(destination) {
    const fromIndex = this.getActiveSection().index;
    const toIndex = getSiblingsIndex(destination, this.sectionElements);
    return fromIndex < toIndex ? "down" : "up";
  }

  scrollPage(destination) {
    if (!destination) return;

    const activeSection = this.getActiveSection();
    if (!activeSection.element || activeSection.element === destination) {
      return;
    }

    const destinationIndex = getSiblingsIndex(destination, this.sectionElements);
    const anchorLink = destination.getAttribute("data-anchor");
    const yMovement = this.getYMovement(destination);

    if (typeof anchorLink !== "undefined") {
      this.setURLHash(anchorLink);
    }

    this.sectionElements.forEach((section) => section.classList.remove("active"));
    this.setActiveSection(destinationIndex);
    this.onLeave(activeSection.index + 1, destinationIndex + 1, yMovement);
    this.activateNavDots(destinationIndex);
    this.lastScrolledDestiny = anchorLink;
    this.lastAnimation = Date.now();

    setTimeout(() => {
      this.afterLoad(anchorLink, destinationIndex + 1);
    }, parseFloat(this.options.scrollingSpeed) * 1000);
  }

  afterLoad(anchorLink, rowIndex) {
    this.ppNav.style.pointerEvents = "";
    removeClasses(document.body, "lqd-stack-moving lqd-stack-moving-up lqd-stack-moving-down");
    const destinationRow = this.sectionElements[rowIndex - 1];
    this.initInview(destinationRow, false);
  }

  activateNavDots(sectionIndex) {
    queryAll("li", this.ppNav).forEach((item, index) => {
      item.classList.toggle("active", index === sectionIndex);
    });
  }

  setURLHash(anchorLink) {
    if (window.location.hash.replace("#", "") !== anchorLink) {
      history.replaceState(null, "", `#${anchorLink}`);
    }
  }

  scrollToAnchor() {
    const anchor = window.location.hash.replace("#", "");
    if (!anchor) return;
    const section = this.sectionElements.find(
      (element) => element.getAttribute("data-anchor") === anchor,
    );
    if (section) {
      this.scrollPage(section);
    }
  }

  hashChangeHandler() {
    const value = window.location.hash.replace("#", "").split("/");
    const sectionAnchor = value[0];
    if (sectionAnchor && sectionAnchor !== this.lastScrolledDestiny) {
      const section = this.sectionElements.find(
        (element) => element.getAttribute("data-anchor") === sectionAnchor,
      );
      this.scrollPage(section);
    }
  }

  isMoving() {
    const timeNow = Date.now();
    return (
      timeNow - this.lastAnimation <
      this.scrollDelay + parseFloat(this.options.scrollingSpeed) * 250
    );
  }

  mouseWheelHandler(event) {
    const curTime = Date.now();
    const value = event.wheelDelta || -event.deltaY || -event.detail;
    const delta = Math.max(-1, Math.min(1, value));
    const horizontalDetection =
      typeof event.wheelDeltaX !== "undefined" || typeof event.deltaX !== "undefined";
    const isScrollingVertically =
      Math.abs(event.wheelDeltaX || 0) < Math.abs(event.wheelDelta || 0) ||
      Math.abs(event.deltaX || 0) < Math.abs(event.deltaY || 0) ||
      !horizontalDetection;

    if (this.scrollings.length > 149) {
      this.scrollings.shift();
    }
    this.scrollings.push(Math.abs(value));

    const timeDiff = curTime - this.prevTime;
    this.prevTime = curTime;
    if (timeDiff > 200) {
      this.scrollings = [];
    }

    if (!this.isMoving()) {
      const activeSection = this.getActiveSection().element;
      const scrollable = this.isScrollable(activeSection);
      const averageEnd = this.getAverage(this.scrollings, 10);
      const averageMiddle = this.getAverage(this.scrollings, 70);
      const isAccelerating = averageEnd >= averageMiddle;

      if (isAccelerating && isScrollingVertically) {
        if (delta < 0) {
          this.scrolling("down", scrollable);
        } else if (delta > 0) {
          this.scrolling("up", scrollable);
        }
      }
    }
  }

  getAverage(elements, number) {
    const lastElements = elements.slice(Math.max(elements.length - number, 1));
    const sum = lastElements.reduce((total, value) => total + value, 0);
    return Math.ceil(sum / number);
  }

  isScrollable(activeSection) {
    return activeSection?.classList.contains("pp-scrollable") ? activeSection : null;
  }

  scrolling(type, scrollable) {
    if (scrollable) {
      const { scrollTop, scrollHeight, clientHeight } = scrollable;
      if (type === "down" && scrollTop + clientHeight < scrollHeight - 5) return;
      if (type === "up" && scrollTop > 5) return;
    }

    if (type === "down") {
      this.moveSectionDown();
    } else {
      this.moveSectionUp();
    }
  }

  getEventsPage(event) {
    return {
      y:
        typeof event.pageY !== "undefined" && (event.pageY || event.pageX)
          ? event.pageY
          : event.touches[0].pageY,
    };
  }

  isReallyTouch(event) {
    return typeof event.pointerType === "undefined" || event.pointerType !== "mouse";
  }

  touchStartHandler(event) {
    if (!this.isReallyTouch(event)) return;
    this.touchStartY = this.getEventsPage(event).y;
  }

  touchMoveHandler(event) {
    if (!this.isReallyTouch(event)) return;

    const activeSection = this.getActiveSection().element;
    const scrollable = this.isScrollable(activeSection);
    if (!scrollable) {
      event.preventDefault();
    }

    if (this.isMoving()) return;

    this.touchEndY = this.getEventsPage(event).y;
    if (
      Math.abs(this.touchStartY - this.touchEndY) >
      (this.element.clientHeight / 100) * this.options.touchSensitivity
    ) {
      if (this.touchStartY > this.touchEndY) {
        this.scrolling("down", scrollable);
      } else if (this.touchEndY > this.touchStartY) {
        this.scrolling("up", scrollable);
      }
    }
  }

  appendPrevNextButtons() {
    if (this.prevNextWrap) return;

    const wrap = document.createElement("div");
    wrap.className = "lqd-stack-prevnext-wrap";
    wrap.innerHTML = `
      <button class="lqd-stack-prevnext-button lqd-stack-prev-button">
        <span class="lqd-stack-button-label">${this.options.prevNextLabels.prev}</span>
        <span class="lqd-stack-button-ext"></span>
      </button>
      <button class="lqd-stack-prevnext-button lqd-stack-next-button">
        <span class="lqd-stack-button-label">${this.options.prevNextLabels.next}</span>
        <span class="lqd-stack-button-ext"></span>
      </button>
    `;
    document.body.appendChild(wrap);
    this.prevNextWrap = wrap;
  }

  prevNextButtonsEvents() {
    query(".lqd-stack-prev-button", this.prevNextWrap)?.addEventListener(
      "click",
      () => this.moveSectionUp(),
    );
    query(".lqd-stack-next-button", this.prevNextWrap)?.addEventListener(
      "click",
      () => this.moveSectionDown(),
    );
  }

  appendPageNumber() {
    if (this.pageNumber) return;

    let pageNumber = null;
    if (this.pageNumbersStyle === "style1") {
      const totalSections = this.sectionElements.length;
      pageNumber = document.createElement("div");
      pageNumber.className = "lqd-stack-page-number";
      pageNumber.innerHTML = `
        <span class="lqd-stack-page-number-counter">
          <span class="lqd-stack-page-number-current"></span>
          <span class="lqd-stack-page-number-passed"></span>
        </span>
        <span class="lqd-stack-page-number-total">${totalSections < 10 ? "0" : ""}${totalSections}</span>
      `;
    } else if (this.pageNumbersStyle === "style2") {
      pageNumber = document.createElement("div");
      pageNumber.className = "lqd-stack-page-number";
      pageNumber.appendChild(query(".pp-nav-ul", this.ppNav).cloneNode(true));
    }

    if (pageNumber) {
      document.body.appendChild(pageNumber);
      this.pageNumber = pageNumber;
    }
  }

  setPageNumber(index) {
    document.body.setAttribute("data-lqd-stack-page", index);
    if (!this.pageNumber) return;

    if (this.pageNumbersStyle === "style1") {
      const current = query(".lqd-stack-page-number-current", this.pageNumber);
      const passed = query(".lqd-stack-page-number-passed", this.pageNumber);
      passed.innerHTML = current.innerHTML;
      current.innerHTML = `${index < 10 ? "0" : ""}${index}`;
      return;
    }

    if (this.pageNumbersStyle === "style2") {
      queryAll("li", this.pageNumber).forEach((item, itemIndex) => {
        item.classList.toggle("active", itemIndex === index - 1);
      });
    }
  }

  addDirectionClassname(direction) {
    if (direction === "down") {
      removeClasses(document.body, "lqd-stack-moving-up");
      addClasses(document.body, "lqd-stack-moving-down");
      this.sectionElements.forEach((section) => {
        removeClasses(section, "lqd-stack-moving-up");
        addClasses(section, "lqd-stack-moving-down");
      });
      return;
    }

    removeClasses(document.body, "lqd-stack-moving-down");
    addClasses(document.body, "lqd-stack-moving-up");
    this.sectionElements.forEach((section) => {
      removeClasses(section, "lqd-stack-moving-down");
      addClasses(section, "lqd-stack-moving-up");
    });
  }

  addLuminosityClassnames(index) {
    const luminosity = this.sectionElements[index].getAttribute(
      "data-section-luminosity",
    );
    removeClasses(document.body, "lqd-active-row-dark lqd-active-row-light");
    addClasses(document.body, `lqd-active-row-${luminosity}`);

    if (window.$liquidMainHeader) {
      removeClasses(window.$liquidMainHeader, "lqd-active-row-dark lqd-active-row-light");
      addClasses(window.$liquidMainHeader, `lqd-active-row-${luminosity}`);
    }

    queryAll(".header-module", window.$liquidMainHeader || document).forEach(
      (module) => {
        removeClasses(module, "lqd-active-row-dark lqd-active-row-light");
        addClasses(module, `lqd-active-row-${luminosity}`);
      },
    );
  }

  initShortcodes(destinationRow, isFirstRender) {
    if (!destinationRow) return;

    if (
      liquidIsMobile() &&
      document.body.hasAttribute("data-disable-animations-onmobile")
    ) {
      queryAll("[data-custom-animations]", destinationRow).forEach((element) => {
        element.classList.add("ca-initvalues-applied");
      });
      return;
    }

    queryAll("[data-custom-animations]", destinationRow).forEach((element) => {
      LiquidCustomAnimations.init(element);
    });

    if (destinationRow.hasAttribute("data-custom-animations")) {
      LiquidCustomAnimations.init(destinationRow);
    }

    if (isFirstRender) {
      this.initInview(destinationRow, true);
    }
  }

  afterRender() {
    const activeSectionIndex = this.sectionElements.findIndex((section) =>
      section.classList.contains("active"),
    );

    this.initShortcodes(this.sectionElements[activeSectionIndex], true);

    this.options.prevNextButtons && this.appendPrevNextButtons();
    this.options.prevNextButtons && this.prevNextButtonsEvents();
    this.options.pageNumber && this.appendPageNumber();
    this.setPageNumber(activeSectionIndex + 1);
    document.body.classList.add("lqd-stack-initiated");
  }

  onLeave(index, nextIndex, direction) {
    const destinationRow = this.sectionElements[nextIndex - 1];
    const originRow = this.sectionElements[index - 1];
    if (!destinationRow || !originRow) return;

    this.ppNav.style.pointerEvents = "none";
    document.body.classList.add("lqd-stack-moving");
    this.setPageNumber(nextIndex);

    removeClasses(destinationRow, "lqd-stack-row-leaving");
    addClasses(destinationRow, "lqd-stack-row-entering");

    removeClasses(originRow, "lqd-stack-row-entering");
    addClasses(originRow, "lqd-stack-row-leaving");

    this.addLuminosityClassnames(nextIndex - 1);
    css(this.ppNavCurrentSpan, {
      transform: `translateY(-${(nextIndex - 1) * 100}%)`,
    });

    this.addDirectionClassname(direction);
    this.initShortcodes(destinationRow, false);

    if (this.mainNavLocalScroll.length) {
      this.handleMainNavLocalScroll();
    }
  }

  initInview(destinationRow, waitForPreloader) {
    if (!destinationRow) return;
    if (document.body.classList.contains("lqd-preloader-activated") && waitForPreloader) {
      document.addEventListener(
        "lqd-preloader-anim-done",
        () => {
          queryAll("[data-inview]", destinationRow).forEach((element) => {
            element.classList.add("is-in-view");
          });
        },
        { once: true },
      );
      return;
    }

    queryAll("[data-inview]", destinationRow).forEach((element) => {
      element.classList.add("is-in-view");
    });
  }

  handleMainNavLocalScroll() {
    queryAll("a[href^='#']", window.$liquidMainHeader || document).forEach((link) => {
      link.addEventListener("click", (event) => {
        const targetHash = link.getAttribute("href");
        if (!targetHash || targetHash === "#") return;
        const targetAnchor = targetHash.replace("#", "");
        const index = this.sectionElements.findIndex((section) => {
          return (
            section.id === targetAnchor ||
            section.getAttribute("data-anchor") === targetAnchor
          );
        });
        if (index >= 0) {
          event.preventDefault();
          this.moveTo(index + 1);
        }
      });
    });
  }

  static init(element, options) {
    const existing = getPluginInstance(element, LiquidStack.pluginName);
    if (existing) return existing;
    const instance = new LiquidStack(element, options);
    setPluginInstance(element, LiquidStack.pluginName, instance);
    return instance;
  }
}

function initSplitText() {
  const elements = queryAll("[data-split-text]").filter((element) => {
    const isCustomAnimation = element.hasAttribute("data-custom-animations");
    const hasCustomAnimationParent = element.parentElement?.closest(
      "[data-custom-animations]",
    );
    const hasAccordionParent = element.closest(".accordion-content");
    const hasTabParent = element.closest(".lqd-tabs-pane");
    const webglSlideshowParent = element.closest("[data-lqd-webgl-slideshow]");

    return (
      !isCustomAnimation &&
      !hasCustomAnimationParent &&
      !hasAccordionParent &&
      !hasTabParent &&
      !webglSlideshowParent
    );
  });

  elements.forEach((element) => {
    LiquidSplitText.init(element);
  });
}

function initCustomAnimations() {
  const stackOptions = window.$liquidContents?.getAttribute("data-stack-options");
  const stackDisableOnMobile =
    stackOptions && JSON.parse(stackOptions).disableOnMobile === true;

  const elements = queryAll("[data-custom-animations]")
    .filter((element) => {
      return (
        (!stackOptions ||
          (stackDisableOnMobile &&
            (liquidIsMobile() || liquidWindowWidth() <= liquidMobileNavBreakpoint()))) &&
        !element.classList.contains("carousel-items")
      );
    })
    .reverse();

  if (!elements.length) return;

  if (
    liquidIsMobile() &&
    document.body.hasAttribute("data-disable-animations-onmobile")
  ) {
    elements.forEach((element) => {
      element.classList.add("ca-initvalues-applied");
    });
    return;
  }

  const run = () => {
    elements.forEach((element) => {
      LiquidCustomAnimations.init(element);
    });
  };

  if (
    document.body.classList.contains("lqd-preloader-activated") &&
    query(".lqd-preloader-wrap")
  ) {
    document.addEventListener("lqd-preloader-anim-done", run, { once: true });
    return;
  }

  run();
}

function initPreloader() {
  if (
    "elementorFrontend" in window &&
    window.elementorFrontend?.isEditMode?.()
  ) {
    return;
  }

  if (!window.liquidPageLoaded) {
    queryAll(".lqd-preloader-wrap").forEach((element) => {
      LiquidPreloader.init(element);
    });
  }

  window.liquidPageLoaded = true;
}

function initStickyHeader() {
  queryAll("[data-sticky-header]").forEach((element) => {
    LiquidStickyHeader.init(element);
  });
}

function initLiquidStack() {
  queryAll("[data-liquid-stack='true']").forEach((element) => {
    LiquidStack.init(element);
  });
}

function init() {
  liquidElements();
  initStickyHeader();
  initSplitText();
  initCustomAnimations();
  initLiquidStack();
}

window.addEventListener("pageshow", initPreloader);
window.addEventListener("load", initPreloader);
document.addEventListener("DOMContentLoaded", init);
